import React from "react"

function Footer() {
    return (
        <footer className="footer has-background-link">
            <div className="content has-text-centered has-text-white">
                <p>
                    <strong className="has-text-white">©  2020 B2 Business. All rights reserved. Privacy Policy.</strong>
                </p>
            </div>
        </footer>
    )
}

export default Footer
